import React from "react";
import { BRAND } from "@/data/content";

export const WhatsAppFloat = () => {
  return (
    <a
      href={`https://wa.me/${BRAND.whatsapp}?text=${encodeURIComponent(
        "¡Hola Polaris! Quiero más información 😊"
      )}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float"
      aria-label="Escríbenos por WhatsApp"
      className="fixed bottom-6 right-6 z-[60] w-14 h-14 rounded-full bg-[#25D366] shadow-lg shadow-[#25D366]/40 flex items-center justify-center hover:scale-110 transition-transform"
    >
      <svg viewBox="0 0 32 32" className="w-7 h-7 fill-white" aria-hidden="true">
        <path d="M16.003 3C9.382 3 4 8.382 4 15.003c0 2.119.553 4.184 1.604 6.005L4 29l8.166-1.57a11.93 11.93 0 0 0 3.837.63h.001C22.62 28.06 28 22.678 28 16.057 28 9.436 22.624 3 16.003 3zm0 21.86h-.001a9.9 9.9 0 0 1-3.43-.6l-.246-.09-4.844.93.92-4.73-.16-.243a9.86 9.86 0 0 1-1.51-5.024c0-5.49 4.47-9.96 9.97-9.96 2.66 0 5.16 1.04 7.04 2.92a9.88 9.88 0 0 1 2.92 7.04c0 5.49-4.47 9.96-9.97 9.96zm5.47-7.46c-.3-.15-1.77-.873-2.044-.973-.273-.1-.473-.15-.673.15-.2.3-.773.973-.948 1.173-.174.2-.349.224-.648.075-.3-.15-1.264-.466-2.408-1.486-.89-.794-1.49-1.774-1.665-2.074-.174-.3-.019-.462.131-.611.135-.134.3-.349.45-.524.149-.174.199-.299.299-.498.1-.2.05-.374-.025-.524-.075-.15-.673-1.623-.922-2.223-.243-.583-.49-.504-.673-.513l-.573-.01c-.2 0-.524.075-.798.374-.274.3-1.047 1.023-1.047 2.495s1.072 2.895 1.222 3.095c.15.2 2.11 3.222 5.11 4.518.714.308 1.272.492 1.706.63.717.228 1.37.196 1.885.119.575-.086 1.77-.723 2.02-1.423.25-.7.25-1.298.175-1.423-.074-.124-.273-.199-.573-.349z" />
      </svg>
    </a>
  );
};
